import { render, staticRenderFns } from "./ContentBox.vue?vue&type=template&id=00a36729&scoped=true&"
import script from "./ContentBox.vue?vue&type=script&lang=js&"
export * from "./ContentBox.vue?vue&type=script&lang=js&"
import style0 from "./ContentBox.vue?vue&type=style&index=0&id=00a36729&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a36729",
  null
  
)

export default component.exports